module.exports = __webpack_public_path__ + "static/img/scene2.830cc9d5.jpg";